import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Pagination,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FooterCustom from "components/FooterCustom/FooterCustom";
import DesignViewBanner from "assets/images/DesignViewBanner.png";
import { useEffect, useState } from "react";
import { fetchCategoryOptions } from "api/categoryService";
import { searchDesignSamplesPublic } from "api/designSampleService";
import { getImageUrlSignedPublic } from "api/AttachmentAPI";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Aos from "aos";
import PreviewModal from "components/PreviewModal/PreviewModal";

function DesignView() {
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [designList, setDesignList] = useState([]);
  const [curPage, setCurPage] = useState(0);
  const [totalProduct, setTotalProduct] = useState(0);
  const [searchData, setSearchData] = useState({
    code: "",
    name: "",
    status: 1,
    page: curPage,
    size: 12,
  });
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const navigate = useNavigate();

  const loadProduct = async (item, Cpage) => {
    if (item == null) return;

    setSearchData({ ...searchData, categoryId: item?.value, page: Cpage });
    searchDesignSamplesPublic({ ...searchData, categoryId: item?.value, page: Cpage })
      .then((res) => {
        if (res?.status === 200) {
          setDesignList(res?.object?.datas);
          setTotalProduct(res?.object?.totals);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  };

  useEffect(() => {
    const loadTemplates = async () => {
      fetchCategoryOptions()
        .then((options) => {
          setTemplates(options);
          setSelectedCategory(options ? options[0] : null);
          loadProduct(options[0], curPage);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    };
    loadTemplates();
    Aos.init({ duration: 800 });
  }, []);

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f8f9fa",
        }}
      >
        <DashboardNavbarCustom />

        {/* Header Section */}
        <div style={{ position: "relative", overflow: "hidden" }}>
          <img src={DesignViewBanner} alt="" style={{ width: "100%", display: "block" }} />

          {/* Lớp phủ hiệu ứng ánh sáng bên trái */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%", // hoặc 40% tùy mức độ lan
              height: "100%",
              background: "linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0))",
              pointerEvents: "none", // không cản sự kiện chuột
            }}
          />
          {/* <div
          style={{
            position: "absolute",
            top: "0%",
            left: "20%",
            color: "#000000",
            fontSize: "24px",
            fontWeight: "500",
          }}
        >
          Mẫu phổ biến/ {selectedCategory?.label}
        </div> */}
        </div>

        <Container maxWidth="lg">
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} md={12}>
              <Box sx={{ pt: 0, mb: 2 }}>
                <Breadcrumbs aria-label="breadcrumb">
                  {/* Trang chủ */}
                  <Typography
                    color="text.secondary"
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate("/")}
                    sx={{
                      cursor: "pointer",
                      fontSize: 12,
                      fontWeight: 400,
                      "&:hover": {
                        color: "text.primary",
                        fontWeight: 500,
                      },
                      "&:focus": {
                        outline: "none",
                        color: "text.primary",
                        fontWeight: 500,
                      },
                    }}
                  >
                    Trang chủ
                  </Typography>

                  {/* Mẫu phổ biến */}
                  <Typography sx={{ fontSize: 12, color: "text.primary", fontWeight: 700 }}>
                    Mẫu phổ biến
                  </Typography>

                  {/* Danh mục được chọn */}
                  {/* <Typography sx={{ fontSize: 12, color: "text.primary", fontWeight: 700 }}>
                  {selectedCategory?.label || "Tất cả"}
                </Typography> */}
                </Breadcrumbs>
              </Box>
            </Grid>

            {/* Cột trái - Sidebar */}
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                borderRight: "1px solid #0094FF",
                pr: 2,
                height: "100%", // ✅ đảm bảo full chiều cao
                display: "flex",
                flexDirection: "column",
                pb: 2,
              }}
            >
              <Typography fontWeight="bold" mb={2} sx={{ color: "#0094FF" }}>
                DANH MỤC
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {templates && Array.isArray(templates)
                  ? templates.map((item, idx) => (
                      <Button
                        key={idx}
                        variant="outlined"
                        // startIcon={item.icon}
                        sx={{
                          justifyContent: "flex-start",
                          borderRadius: 2,
                          borderColor: "#0094FF",
                          color: "#0094FF",
                          fontWeight: 500,
                          textTransform: "none",
                        }}
                        value={item?.value}
                        onClick={() => {
                          setSelectedCategory(item);
                          setCurPage(0);
                          loadProduct(item, 0);
                        }}
                      >
                        {item?.label}
                      </Button>
                    ))
                  : ""}
              </Box>
            </Grid>

            {/* Cột phải - Danh sách sản phẩm */}
            <Grid item xs={12} md={9}>
              <Typography variant="h6" fontWeight="bold" mb={3}>
                {selectedCategory?.label} ({totalProduct} sản phẩm)
              </Typography>

              <Grid container spacing={3} alignItems="stretch">
                {designList && Array.isArray(designList)
                  ? designList.map((product, idx) => {
                      const imageUrl = getImageUrlSignedPublic(product?.attachment);
                      return (
                        <Grid key={idx} item xs={12} sm={4} md={4}>
                          <Box
                            sx={{
                              textAlign: "center",
                              p: 2,
                              borderRadius: 2,
                              height: "100%",
                              minHeight: 320,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              "&:hover": {
                                boxShadow: 3,
                                transform: "translateY(-4px)",
                                backgroundColor: "#f5f5f5",
                              },
                            }}
                            onClick={() => {
                              setPreviewImages([{ imageUrl }]);
                              setPreviewModalOpen(true);
                            }}
                          >
                            {/* Hình ảnh */}
                            <Box
                              sx={{
                                height: 200,
                                width: "100%",
                                overflow: "hidden",
                                borderRadius: 1,
                              }}
                            >
                              <img
                                src={imageUrl}
                                alt={product.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  display: "block",
                                }}
                              />
                            </Box>

                            {/* Tên mẫu thiết kế */}
                            <Tooltip title={product?.designSampleName || ""}>
                              <Typography
                                fontWeight={400}
                                fontSize={16}
                                mt={2}
                                noWrap
                                sx={{
                                  textAlign: "left",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {product?.designSampleName}
                              </Typography>
                            </Tooltip>

                            {/* Nút liên hệ */}
                            <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
                              <Link
                                href="https://zalo.me/0903132585"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                  color: "#0094FF",
                                  px: 1,
                                  py: 0.5,
                                  fontSize: 16,
                                  fontWeight: 400,
                                  display: "inline-block",
                                  transition: "background-color 0.2s ease",
                                  "&:hover, &:focus": {
                                    backgroundColor: "#E3F2FD",
                                    border: "1px solid #0094FF",
                                    borderRadius: "4px",
                                  },
                                }}
                              >
                                Liên hệ
                              </Link>
                            </Box>
                          </Box>
                        </Grid>
                      );
                    })
                  : ""}
              </Grid>
              <Stack spacing={2} alignItems="center" mt={4}>
                <Pagination
                  count={Math.ceil(totalProduct / 12)}
                  page={curPage + 1}
                  onChange={(event, value) => {
                    setCurPage(value - 1);
                    loadProduct(selectedCategory, value - 1);
                  }}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            </Grid>
          </Grid>
        </Container>

        <FooterCustom />

        <Button
          onClick={handleScrollTop}
          variant="contained"
          color="primary"
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 999,
            width: "36px !important",
            height: "36px !important",
            minWidth: "unset",
            minHeight: "unset",
            padding: 0,
            borderRadius: "50%",
            boxShadow: 3,
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          <KeyboardArrowUpIcon />
        </Button>
      </Box>

      <PreviewModal
        open={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        previews={previewImages}
      />
    </>
  );
}

export default DesignView;
